angular.module("UI8.components").component("passModal", {
  template: `<div class="modal modal--pass">
      <button class="modal__close" ui8-toggle-class="pass-pricing-modal" ui8-track-event="Close Pass Modal"></button>
      <div class="modal__container">
        <div class="modal__head">
          <h1 class="modal__title">{{ $ctrl.subtitle }}</h1>
          <p class="modal__subtitle">{{ $ctrl.description }}</p>
        </div>
        <pass-pricing subscriptions="::$ctrl.subscriptions" lifetime="::$ctrl.lifetime" promo="::$ctrl.promo" close-modal="true"></pass-pricing>
        <div class="modal__hint">All plans may be canceled at any time and you retain access to download until expired.</div>
      </div>
      <div class="modal__backdrop" ui8-toggle-class="pass-pricing-modal" ui8-track-event="Close Pass Modal"></div>
    </div>`,

  controller: function () {
    // console.log("passModal");
    var ctrl = this;

    ctrl.$onInit = function () {
      // console.log("passModal init");
      if (!ctrl.subtitle) ctrl.subtitle = UI8.passSubtitle;
      if (!ctrl.description) ctrl.description = UI8.passDescription;
      if (!ctrl.subscriptions) ctrl.subscriptions = UI8.subscriptions;
      if (!ctrl.lifetime) ctrl.lifetime = UI8.lifetime;
      if (!ctrl.promo) ctrl.promo = UI8.promo;
    };
  },

  bindings: {
    subscriptions: "<?",
    lifetime: "<?",
    promo: "<?",
    subtitle: "<?",
    description: "<?",
  },
});
